/* =====================================================================
 * Legal-document version stamps.
 *
 * Phase 12-5b moved these constants out of the B2C host (`askyourai/src/
 * content/legal/types.ts`) into the shared workspace-ui package so the
 * settings + cookie-consent surfaces can be hoisted to `@auw/workspace-ui`
 * and reused by `apps/enterprise` without dragging the host's legal
 * content tree along.
 *
 * They identify the *version* of each legal text the user has agreed
 * to. The strings themselves are deliberately documentary — a fresh
 * agreement (or a re-confirmation prompt) is needed whenever any of
 * these change because the persisted consent record carries the
 * version string and an `agreed_at` timestamp.
 *
 * Tenant override:
 *   These constants are NOT tenant-scoped today — every host that
 *   ships the shared settings tree shows the same legal-doc version.
 *   If an on-prem customer needs to publish their own privacy policy
 *   or terms (and re-prompt their users when those change), the next
 *   pass will route these through `tenant.legal.{privacy,terms,...}`
 *   in the manifest. For now we keep the historic B2C values to
 *   preserve sign-in behaviour for the live `askyour.ai` users.
 * ===================================================================== */

export const PRIVACY_VERSION = '2026-03-26-ga4';
export const TERMS_VERSION = '2026-03-26-billing';
export const COOKIE_CONSENT_VERSION = '2026-03-26-ga4';
export const MARKETING_VERSION = '2026-03-26';
